import {BaseModel} from "../base-model";

export class PredictionSelectionModel extends BaseModel {
  predictionId: Number;
  num: Number;
  date: Date;

  constructor(predictionId: Number, num: Number, date: String) {
    super();

    this.predictionId = predictionId;
    this.num = num;
    this.date = date;
  }

  equals(model: PredictionSelectionModel): * {
    const isObjectTypeEquals = this.num === model.num;
    const isIdsEquals = this.predictionId === model.predictionId;

    return isObjectTypeEquals && isIdsEquals;
  }
}


